import { allSectionStatsForCourseFetchSucceeded } from ".";

export function withCourseSectionStatsFetchState<ArgsT extends any[]>(
  courseId: string
) {
  return function (selector: (state: any, ...args: ArgsT) => any) {
    return function (state: any, ...args: ArgsT) {
      if (!allSectionStatsForCourseFetchSucceeded(state, courseId)) {
        return null;
      }

      return selector(state, ...args);
    };
  };
}
